import React from "react"
import { AspectRatio, Flex, Image, Text } from "@chakra-ui/react"

import { useShopify } from "@app/hooks/useShopify"

type Props = {
  activeSibling: GatsbyTypes.SanityProduct | null
  onClose: () => void
  setSelectedSiblingHandle: (handle: string) => void
  sibling: GatsbyTypes.SanityProduct
}

export const ProductStockSiblingDropdownItem: React.FC<Props> = React.memo(
  ({ activeSibling, onClose, setSelectedSiblingHandle, sibling }) => {
    const { imageNormaliser } = useShopify()

    const active = sibling?.shopify?.handle === activeSibling?.shopify?.handle
    const image = imageNormaliser(sibling.images?.[0] || null, 200)

    return (
      <Flex
        as="button"
        w="full"
        textAlign="left"
        color={active ? "brand.white" : "brand.darkBlue"}
        bgColor={active ? "brand.darkBlue" : "brand.white"}
        px="22px"
        py="14px"
        borderBottom="1px solid"
        borderColor="#bbb"
        alignItems="center"
        onClick={() => {
          setSelectedSiblingHandle(sibling?.shopify?.handle)
          onClose()
        }}
        aria-label={sibling?.colorTitle}
        title={sibling?.colorTitle}
        _last={{ borderBottom: "none" }}
        _hover={{
          color: "primary.white",
          bgColor: "brand.darkBlue",
          textDecoration: "none",
        }}
      >
        <AspectRatio ratio={6 / 7} backgroundColor="primary.white" borderRadius="10%" width={8} marginRight={2}>
          <Image src={image?.src} objectFit="cover" boxSize="100%" objectPosition="center" />
        </AspectRatio>
        <Text fontSize={13.3333} flex={1} ml="10px">
          {sibling?.colorTitle}
        </Text>
      </Flex>
    )
  }
)
